module.exports = __webpack_public_path__ + "img/clock_duration.861a952c.svg";